import React from 'react';
import { Box } from '@mui/material';
import LoginForm from '../components/LoginForm';

interface LoginPageProps {
  onLogin?: (email: string) => void;
  onError?: (error: string) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin, onError }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#FBF9F6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 2
      }}
    >
      <LoginForm onLogin={onLogin} onError={onError} />
    </Box>
  );
};

export default LoginPage;
